// extracted by mini-css-extract-plugin
export default {"chromeIcon":"BrowserInfo_chromeIcon__RnYis","chromiumIcon":"BrowserInfo_chromiumIcon__XxBAr","edgeChromiumIcon":"BrowserInfo_edgeChromiumIcon__5Wzpo"};